import AbstractReporter from './AbstractReporter';
import log from 'loglevel';

/**
 * 直播上报code码
 * http://wiki.vhallops.com/pages/viewpage.action?pageId=310543311
 */
const LIVE_CODE = {
  Start: 102001, // 播放器初始化结束，调度数据返回之前
  Info: 102002, // 心跳包
  Resume: 102004, // 触发video PLAY事件
  Pause: 102005, // 触发video PAUSE事件
  Error: 104001, // 播放错误：开始播放，播放过程中
  TouchPlay: 102009 // 开始播放，调用sdk play() 方法
};

/**
 * 直播日志上报
 *
 * @export
 * @class LiveReporter
 * @extends {AbstractReporter}
 */
export default class LiveReporter extends AbstractReporter {
  constructor() {
    super();
    this.isPaused = false;
  }

  __ready() {
    super.__ready();
    this.__sendLog(LIVE_CODE.Start, {
      errcode: '2001'
    });
  }

  __touchPlay() {
    super.__touchPlay();

    this.__sendLog(LIVE_CODE.TouchPlay, {
      errcode: '2006'
    });
  }

  __lag(e) {
    super.__lag(e);
  }

  __lagRecover(e) {
    super.__lagRecover(e);
  }

  __play(e) {
    super.__play(e);
    // if (this.isPaused) {
    //   this.isPaused = false;
    //   this.__sendLog(LIVE_CODE.Resume, {
    //     errcode: '2004'
    //   });
    // }
  }

  __pause(e) {
    super.__pause(e);
    // this.isPaused = true;
    // this.__sendLog(LIVE_CODE.Pause, {
    //   errcode: '2005'
    // });
  }

  __error(e) {
    super.__error(e);
    // this.__sendLog(LIVE_CODE.Error, {
    //   errcode: '4001'
    // });
  }
  
  infoPack() {
    // 数据修复，避免出现29998、59999之类的数据
    let duration = this._playInfoDuration / 1000;
    this._playInfoDuration = Math.round(duration) * 1000;
    // 屏蔽由于部分手机计时器不准确，导致出现播放时长超过心跳时长的情况
    this._playInfoDuration =
      this._playInfoDuration > this._infoPackIntervalMs ? this._infoPackIntervalMs : this._playInfoDuration;

    const obj = {
      bt: this._bt,
      bc: this._lagCount,
      tt: this._playInfoDuration,
      tf: this.httpDownloadSize + this.p2pDownloadSize,
      errcode: this.player.getReadyState() === 4 ? 2002 : 4001
    };
    // 播放地址
    let el = this.getURLInfo();
    if (el.protocol.indexOf('webrtc') > -1) {
      obj.tf = 10000; // 大数据计费添加流量，大数据计算值>0 不会过滤；
    }
    log.info('信息包内容：', JSON.stringify(obj));
    this.__sendLog(LIVE_CODE.Info, obj);
    super.infoPack();
  }

  destroy() {
    this.infoPack();
    super.destroy();
  }
}
